import { useState } from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Typography from '@material-ui/core/Typography'
import useStyles from './tab.styles'

const CustomTab = (props) => {
  const {
    items,
    handleChange,
    allowScroll,
    color,
    align,
  } = props
  const styles = useStyles({ allowScroll, color, align })
  const [selectedItem, setValue] = useState(0)

  const internalHandleChange = (newValue, event) => {
    setValue(newValue)

    if (handleChange) {
      handleChange(newValue, event)
    }
  }

  return (
    <Box className={styles.tabs} py={2}>
      {items.map((item, index) => {
        const TabStyles = selectedItem === index ? `${styles.tab} ${styles.selected}` : styles.tab

        return (
          <Typography className={TabStyles} onClick={() => internalHandleChange(index)} key={item.series ? item.series : item.headline} variant="subtitle2" component="button">
            {item.series ? item.series : item.headline}
          </Typography>
        )
      })}
    </Box>
  )
}

CustomTab.propTypes = {
  color: PropTypes.string,
  align: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      series: PropTypes.string,
      headline: PropTypes.string,
    }),
  ),
  handleChange: PropTypes.func,
  allowScroll: PropTypes.bool,
}

CustomTab.defaultProps = {}

export default CustomTab
